import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col md="4">
            <span className="copyright">Copyright &copy; QVirt 2019</span>
          </Col>
          <Col md="4">
            <ul className="list-inline social-buttons">
              <li className="list-inline-item">
                <button className="btn btn-social">
                  <i className="fab fa-twitter"></i>
                </button>
              </li>
              <li className="list-inline-item">
                <button className="btn btn-social">
                  <i className="fab fa-facebook-f"></i>
                </button>
              </li>
              <li className="list-inline-item">
                <button className="btn btn-social">
                  <i className="fab fa-linkedin-in"></i>
                </button>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
